import React, { useEffect, useRef, useState } from "react";
import MetaTags from "react-meta-tags";

//import Breadcrumbs
import Breadcrumbs from "../../components/common/Breadcrumb";
import { Loading } from "../../components/common/Loading";

import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";

import { FieldArray, Form, Formik } from "formik";
import { XSelect } from "../../components/common/inputs/XSelect";
import { XTextArea } from "../../components/common/inputs/XTextArea";
import { XTextBox } from "../../components/common/inputs/XTextBox";
import { InvoiceFields } from "../../fields/InvoiceFields";
import { Endpoints } from "../../utils/Endpoints";
import InvoiceSummary from "../Sales/InvoiceSummary";
import { useFocus } from "../../hooks/useFocus";
import { ApiCore } from "../../helpers/api_helper";
import { amountToCurrency, currentDate, round, taxCalculator } from "../../utils/Helpers";
import { ISelectOption } from "../../interfaces/inputs/ISelectOption";
import { XDatePickerField } from "../../components/common/inputs/XDatePickerField";
import { XCheckbox } from "../../components/common/inputs/XCheckbox";
import { AxiosError, AxiosResponse } from "axios";
import XModal from "../../components/common/XModal";
import { SupplierFields } from "../../fields/SupplierFields";
import { SupplierSchema } from "../../schemas/SupplierSchema";
import CreateForm from "../../components/forms/CreateForm";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { ISupplier } from "../../interfaces/suppliers/ISupplier";
import { ProductFields } from "../../fields/ProductFields";
import { ProductSchema } from "../../schemas/ProductSchema";
import { IProduct } from "../../interfaces/products/IProduct";
import { XSearchableSelect } from "../../components/common/inputs/XSearchableSelect";
import {toast, ToastContainer} from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

const NewSale = () => {
  const [defaults, setDefaults] = useState<any>({});
  const [companies, setCompanies] = useState<any>([]);
  const [products, setProducts] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingInvoice, setLoadingInvoice] = useState<boolean>(true);
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const params = new URLSearchParams(useLocation().search);
  const invtype = params.get("invtype") ? params.get("invtype") : "sale";
  const [showSupplierDialog, setShowSupplierDialog] = useState<boolean>(false);
  const [showProductDialog, setShowProductDialog] = useState<boolean>(false);
  const getDefaultAccount = () => {
    if (defaults.accounts) {
      if (invtype == "sale" && defaults.accounts.receivable) {
        return defaults.accounts.receivable;
      } else if (invtype == "purchase" && defaults.accounts.payable) {
        return defaults.accounts.payable;
      }
    }
    return 0;
  };
  const [invoice, setInvoice] = useState<any>(null);

  const history = useHistory();

  const request = new ApiCore();

  const invoiceId = params.get("id") ? params.get("id") : null;
  const saleId = params.get("saleId") ? params.get("saleId") : null;

  if (invoiceId) {
    useEffect(() => {
      request
        .get(Endpoints.invoices + "/" + invoiceId)
        .then((response: AxiosResponse) => {
          setInvoice(response.data);
          setLoadingInvoice(false);
        })
        .catch(error => {
          console.error(error);
        });
    }, []);
  }

  if (saleId) {
    useEffect(() => {
      request
        .get(Endpoints.salesOrders + "/" + saleId)
        .then((response: AxiosResponse) => {
          let sale = response.data;
          
          let inv = {
            company_id: invtype != "purchase" && sale.company_id ? sale.company_id : "",
            currency_id: sale.currency ? sale.currency.id : "",
            sale_id: saleId,
            currency: sale.currency,
            invtype: invtype,
            created: currentDate(),
            items: sale.saleitems.map((item: any) => {
              item.craccountid = invtype == "purchase" ? item.product.purchaseaccount : item.product.salesaccount
              item.tax_id = invtype == "purchase" ? item.product.purchasetax : item.product.salestax
              delete item.sale_id;
              delete item.tenant_id;
              delete item.id;
              return item;
            }),
          };
          setInvoice(inv);
          setLoadingInvoice(false);
        })
        .catch(error => {
          console.error(error);
        });
    }, []);
  }

  useEffect(() => {
    request
      .get(Endpoints.defaults)
      .then((response: AxiosResponse) => {
        setDefaults(response.data);
        setLoading(false);
        if (!invoiceId && !saleId) {
          setLoadingInvoice(false);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    request
      .get(Endpoints.companies, {})
      .then((response: AxiosResponse) => {
        let options: any = [];
        options = response.data.companies.map((data: any) => ({
          value: data.id,
          label: data.name || data.taxid,
          data: JSON.stringify(data),
        }));
        setCompanies(options);
        //initialValues.company_id = "";
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    request
      .get(Endpoints.products, {})
      .then((response: AxiosResponse) => {
        const { products, totalRecords } = response.data;
        let options: any = [];
        options = products.map((data: any) => ({
          value: data.id,
          label: data.name || data.taxid,
          data: JSON.stringify(data),
        }));
        setProducts(options);
        //initialValues.items[0].product_id = "";
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  const invoiceTypes: ISelectOption[] = [
    { value: "purchase", text: "Purchase" },
    { value: "sale", text: "Sale" },
  ];

  let initialValues: any = {};
  if (invoice) {
    initialValues = {
      company_id: invoice.company_id ? invoice.company_id : "",
      account_id: invoice.account_id ? invoice.account_id : getDefaultAccount(),
      currency_id: invoice.currency ? invoice.currency.id : "",
      currency: invoice.currency,
      location_id: invoice.location_id ? invoice.location_id : "",
      whduty_id: invoice.whduty_id ? invoice.whduty_id : "",
      discount: invoice.discount ? invoice.discount : "",
      invtype: invoice.invtype,
      sale_id: invoice.sale_id,
      updatestock: 0,
      paid: params.get("paid") ? 1 : 0,
      created: invoice.created ? invoice.created : "",
      rate: invoice.rate ? invoice.rate : 1,
      items: invoice.items.map((item: any) => {
        if (!item.tax_id) {
          item.tax_id = "";
        }
        return item;
      }),
    };
  } else {
    initialValues = {
      company_id: "",
      account_id: getDefaultAccount(),
      currency_id: defaults.currency ? defaults.currency.id : "",
      currency: defaults.currency,
      location_id: "",
      whduty_id: "",
      discount: "",
      invtype: invtype,
      updatestock: 0,
      paid: params.get("paid") ? 1 : 0,
      created: currentDate(),
      rate: defaults.currency ? defaults.currency.rate : 1,
      items: [
        {
          product_id: "",
          craccountid: "",
          particulars: "",
          rate: 0.0,
          quantity: 1,
          amount: 0.0,
          tax_id: "",
          tax: null,
        },
      ],
    };
  }

  const handleLineItemChange = (index: number) => (event: any) => {};

  const computeSubTotal = (items: [any]) => {
    const sum = items.reduce((accumulator, object) => {
      return accumulator + object.amount;
    }, 0);
    return sum;
  };

  const calculateGrandTotal = (items: [any], discount: number) => {
    const dis = computeDiscount(items, discount);
    const subTotal = computeSubTotal(items);
    return subTotal - dis;
  };

  const computeDiscount = (items: [any], discount: number) => {
    return (discount * computeSubTotal(items)) / 100;
  };

  const computeAmount = (index: number, item: any, setFieldValue: any) => {
    setFieldValue(`items.${index}.amount`, item.rate * item.quantity);
  };

  const computeTax = (items: [any]) => {
    const sum = items.reduce((accumulator, object) => {
      return (
        accumulator + taxCalculator(object)
      );
    }, 0);
    return sum;
  };

  const handleClickNewCompany = () => {
    setShowSupplierDialog(true);
  };

  const handleClickNewProduct = (index: number) => {
    setSelectedIndex(index);
    setShowProductDialog(true);
  };

  const handleCreateCompany = (supplier: ISupplier, f: any) => {
    const updatedCompanies = [
      ...companies,
      {
        value: supplier.id,
        label: supplier.name,
        data: JSON.stringify(supplier),
      },
    ];
    setCompanies(updatedCompanies);
    f("company_id", supplier.id);
  };

  const handleCreateProduct = (product: IProduct, f: any, values: any) => {
    const updatedProducts = [
      ...products,
      {
        value: product.id,
        label: product.name,
        data: JSON.stringify(product),
      },
    ];

    setProducts(updatedProducts);
    f(`items.${selectedIndex}.product_id`, product.id);

    f(`items.${selectedIndex}.quantity`, 1);
    f(`items.${selectedIndex}.rate`, product.sellingprice);
    f(`items.${selectedIndex}.particulars`, product.name);
    if (values.invtype == "sale") {
      f(`items.${selectedIndex}.craccountid`, product.salesaccount);
    } else {
      f(`items.${selectedIndex}.craccountid`, product.purchaseaccount);
    }
  };

  const handleSubmit = (values: any) => {
    const request_body = values;
    for (let i = 0; i < request_body.items.length; i++) {
      delete request_body.items[i].tax;
      delete request_body.items[i].product;
    }
    
    request_body.generaljournals_attributes = request_body.items;
    console.log(request_body);
    if (invoiceId) {
      request_body.id = invoiceId;
      toast.promise(request.update(Endpoints.invoices + "/" + invoiceId, request_body), {
        pending: "Please wait..",
        error: {
          render({data}) {
            return data;
          }
        }
      })
        .then((response: AxiosResponse) => {
          history.push("/invoices-detail/" + response.data.id);
        });
    } else {
      toast.promise(request.create(Endpoints.invoices, request_body), {
        pending: "Please wait..",
        error: {
          render({data}) {
            return data;
          }
        }
      }).then((response: AxiosResponse) => {
          history.push("/invoices-detail/" + response.data.id);
        });
    }
  };

  const getCurrencyCode = (currency: any) => {
    return currency ? currency.code : "UGX";
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>New Invoice | Treda</title>
        </MetaTags>

        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Transactions" breadcrumbItem="New Invoice" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                <ToastContainer />
                  {(loading || loadingInvoice) && (
                    <Loading label="Loading invoice. Please wait." />
                  )}
                  {!loading && !loadingInvoice && (
                    <>
                      <Formik
                        initialValues={initialValues}
                        enableReinitialize
                        validateOnBlur
                        onSubmit={(values: any) => handleSubmit(values)}
                      >
                        {({
                          isSubmitting,
                          setFieldValue,
                          values,
                          errors,
                          touched,
                        }) => (
                          <>
                            <XModal
                              title={
                                values.invtype == "sale"
                                  ? "Add a customer"
                                  : "Add a supplier"
                              }
                              width={"lg"}
                              open={showSupplierDialog}
                              toggle={() =>
                                setShowSupplierDialog(!showSupplierDialog)
                              }
                              onClose={() => setShowSupplierDialog(false)}
                            >
                              <CreateForm
                                fields={SupplierFields}
                                initialValues={initialValues}
                                enableReinitialize={true}
                                submitEndpoint={Endpoints.companies}
                                submitButtonLabel={"save"}
                                validationSchema={SupplierSchema}
                                debug={false}
                                handleUpdate={(supplier: ISupplier) => {
                                  handleCreateCompany(supplier, setFieldValue);
                                }}
                                onClose={() => setShowSupplierDialog(false)}
                              />
                            </XModal>
                            <XModal
                              title={"Add a product"}
                              width={"lg"}
                              open={showProductDialog}
                              toggle={() =>
                                setShowProductDialog(!showProductDialog)
                              }
                              onClose={() => setShowProductDialog(false)}
                            >
                              <CreateForm
                                fields={ProductFields}
                                initialValues={initialValues}
                                submitEndpoint={Endpoints.products}
                                submitButtonLabel={"Create Product"}
                                validationSchema={ProductSchema}
                                debug={false}
                                handleUpdate={(product: IProduct) => {
                                  handleCreateProduct(
                                    product,
                                    setFieldValue,
                                    values
                                  );
                                }}
                                onClose={() => setShowProductDialog(false)}
                              />
                            </XModal>
                            <Form>
                              <Row>
                                <Col lg={2}>
                                  <XSelect
                                    key="invtype"
                                    id="invtype"
                                    name={"invtype"}
                                    options={invoiceTypes}
                                    label={"Type"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <XDatePickerField
                                    key="created"
                                    id="created"
                                    name={"created"}
                                    label={"Date"}
                                    touched={touched}
                                    onChange={setFieldValue}
                                    value={values.created}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={3}>
                                  <XSearchableSelect
                                    key="company_id"
                                    id="company_id"
                                    value={values.company_id}
                                    name={"company_id"}
                                    options={companies}
                                    label={"Company"}
                                    handleNewClick={e => {
                                      handleClickNewCompany();
                                    }}
                                    onChange={(value: any) => {
                                      setFieldValue("company_id", value.value);
                                    }}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>

                                <Col lg={3}>
                                  <XSearchableSelect
                                    key="account_id"
                                    id="account_id"
                                    name={"account_id"}
                                    onChange={(value: any) => {
                                      setFieldValue("account_id", value.value);
                                    }}
                                    dataSrc={Endpoints.accounts}
                                    value={values.account_id}
                                    dataType={"accounts"}
                                    label={"Debit Account"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <XTextBox
                                    id="discount"
                                    type={"text"}
                                    name={"discount"}
                                    label={"Discount (%)"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={2}>
                                  <XSelect
                                    key="whduty_id"
                                    id="whduty_id"
                                    name={"whduty_id"}
                                    dataSrc={Endpoints.whduties}
                                    dataType={"whduties"}
                                    label={"Withholding Tax"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>

                                <Col lg={2}>
                                  <XSelect
                                    key="location_id"
                                    id="location_id"
                                    name={"location_id"}
                                    dataSrc={Endpoints.locations}
                                    dataType={"locations"}
                                    label={"Stock Location"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <XSelect
                                    key="currency_id"
                                    id="currency_id"
                                    name={"currency_id"}
                                    dataSrc={Endpoints.currencies}
                                    onChange={(field: any) => {
                                      const data = JSON.parse(
                                        field.target.selectedOptions[0].dataset
                                          .raw
                                      );

                                      setFieldValue(field.target.name, data.id);
                                      setFieldValue(`currency`, data);
                                      setFieldValue(`rate`, data.rate);
                                    }}
                                    dataType={"currencies"}
                                    label={"Currency"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={1}>
                                  <XTextBox
                                    key="rate"
                                    id="rate"
                                    type={"text"}
                                    name={"rate"}
                                    label={"Rate"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={3}>
                                  <XCheckbox
                                    key="updatestock"
                                    id="updatestock"
                                    name={"updatestock"}
                                    label={"Update Stock"}
                                    value="1"
                                    includeTopPadding={true}
                                    onChange={setFieldValue}
                                    size={{}}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <XCheckbox
                                    key="paid"
                                    id="paid"
                                    name={"paid"}
                                    label={"Paid"}
                                    value="1"
                                    includeTopPadding={true}
                                    onChange={setFieldValue}
                                    checked={values.paid == 1}
                                    size={{}}
                                  />
                                </Col>
                              </Row>

                              <Row>
                                <Col lg={12}>
                                  <div
                                    className={
                                      "mt-4 border-top border-bottom pt-2 bg-light"
                                    }
                                  >
                                    <Row>
                                      <Col lg={2} className="px-4">
                                        <h6>Item</h6>
                                      </Col>
                                      <Col lg={1}>
                                        <h6>Qty</h6>
                                      </Col>
                                      <Col lg={1}>
                                        <h6>Rate</h6>
                                      </Col>
                                      <Col lg={2}>
                                        <h6>Particulars</h6>
                                      </Col>
                                      <Col lg={1}>
                                        <h6>Tax</h6>
                                      </Col>
                                      <Col lg={2}>
                                        <h6>Account</h6>
                                      </Col>
                                      <Col lg={2}>
                                        <h6>Amount</h6>
                                      </Col>
                                      <Col lg={1}></Col>
                                    </Row>
                                  </div>
                                </Col>

                                <Col lg={12}>
                                  <FieldArray
                                    name={"items"}
                                    render={arrayHelpers => (
                                      <div className={"py-3"}>
                                        {values.items &&
                                          values.items.map(
                                            (item: any, index: number) => (
                                              <Row key={index}>
                                                <Col lg={2}>
                                                  <XSearchableSelect
                                                    onChange={(field: any) => {
                                                      const productId = field.value;
                                                      if (productId == -1) {
                                                        handleClickNewProduct(index);
                                                      } else {
                                                        setFieldValue(`items.${index}.product_id`,productId);
                                                        const data = JSON.parse(field.data);

                                                        setFieldValue(`items.${index}.quantity`,1);
                                                        setFieldValue(`items.${index}.rate`,data.sellingprice);
                                                        setFieldValue(`items.${index}.particulars`,data.name);
                                                        if (values.invtype =="sale") {
                                                          setFieldValue(`items.${index}.craccountid`,data.salesaccount);
                                                        } else {
                                                          setFieldValue(`items.${index}.craccountid`,data.purchaseaccount);
                                                        }
                                                      }
                                                    }}
                                                    allowAddNew={true}
                                                    options={products}
                                                    id={`items.${index}.product_id`}
                                                    name={`items.${index}.product_id`}
                                                    value={values.items[index].product_id}
                                                    touched={touched}
                                                  />
                                                </Col>
                                                <Col lg={1}>
                                                  <XTextBox
                                                    id={`items.${index}.quantity`}
                                                    type={"text"}
                                                    handleBlur={event => {
                                                      computeAmount(
                                                        index,
                                                        item,
                                                        setFieldValue
                                                      );
                                                    }}
                                                    name={`items.${index}.quantity`}
                                                    touched={touched}
                                                    errors={errors}
                                                  />
                                                </Col>
                                                <Col lg={1}>
                                                  <XTextBox
                                                    id={`items.${index}.rate`}
                                                    type={"text"}
                                                    handleBlur={event => {
                                                      computeAmount(
                                                        index,
                                                        item,
                                                        setFieldValue
                                                      );
                                                    }}
                                                    name={`items.${index}.rate`}
                                                    touched={touched}
                                                    errors={errors}
                                                  />
                                                </Col>
                                                <Col lg={2}>
                                                  <XTextBox
                                                    id={`items.${index}.particulars`}
                                                    type={"text"}
                                                    name={`items.${index}.particulars`}
                                                    touched={touched}
                                                    errors={errors}
                                                  />
                                                </Col>
                                                <Col lg={1}>
                                                  <XSelect
                                                    onChange={(field: any) => {
                                                      const data = JSON.parse(
                                                        field.target
                                                          .selectedOptions[0]
                                                          .dataset.raw
                                                      );

                                                      setFieldValue(
                                                        field.target.name,
                                                        data.id
                                                      );
                                                      setFieldValue(
                                                        `items.${index}.tax`,
                                                        data
                                                      );
                                                    }}
                                                    dataType={"taxes"}
                                                    dataSrc={Endpoints.taxes}
                                                    id={`items.${index}.tax_id`}
                                                    name={`items.${index}.tax_id`}
                                                    touched={touched}
                                                  />
                                                </Col>
                                                <Col lg={2}>
                                                  <XSearchableSelect
                                                    dataType={"accounts"}
                                                    dataSrc={Endpoints.accounts}
                                                    id={`items.${index}.craccountid`}
                                                    name={`items.${index}.craccountid`}
                                                    value={values.items[index].craccountid}
                                                    onChange={(value: any) => {
                                                      setFieldValue(`items.${index}.craccountid`, value.value);
                                                    }}
                                                    touched={touched} />
                                                </Col>
                                                <Col lg={2}>
                                                  <XTextBox
                                                    id={`items.${index}.amount`}
                                                    type={"text"}
                                                    onChange={handleLineItemChange(
                                                      index
                                                    )}
                                                    name={`items.${index}.amount`}
                                                    touched={touched}
                                                    errors={errors}
                                                  />
                                                </Col>
                                                <Col lg={1}>
                                                  <Button
                                                    className={
                                                      "btn btn-soft-danger"
                                                    }
                                                    to={"#"}
                                                  >
                                                    <i
                                                      className="fa fa-times"
                                                      onClick={() =>
                                                        arrayHelpers.remove(
                                                          index
                                                        )
                                                      }
                                                    ></i>
                                                  </Button>
                                                </Col>
                                              </Row>
                                            )
                                          )}
                                        <Button
                                          className={"btn btn-soft-primary"}
                                          type="button"
                                          onClick={() =>
                                            arrayHelpers.push({
                                              product_id: "",
                                              craccountid: "",
                                              particulars: "",
                                              rate: "",
                                              quantity: "",
                                              amount: "",
                                              tax_id: "",
                                            })
                                          }
                                        >
                                          <i className={"mdi mdi-plus"}></i> Add
                                          Item
                                        </Button>
                                      </div>
                                    )}
                                  />
                                </Col>
                              </Row>

                              <Row>
                                <XTextArea
                                  id="remarks"
                                  label="Remarks"
                                  name="remarks"
                                  size={{ lg: 12 }}
                                  touched={touched}
                                />
                              </Row>

                              <Row>
                                <Col lg={3}>
                                  <InvoiceSummary
                                    label={"Sub total"}
                                    icon="mdi mdi-calculator"
                                    value={
                                      getCurrencyCode(values.currency) +
                                      " " +
                                      amountToCurrency(
                                        computeSubTotal(values.items)
                                      )
                                    }
                                  />
                                </Col>
                                <Col lg={3}>
                                  <InvoiceSummary
                                    label={"Tax"}
                                    icon="mdi mdi-percent"
                                    value={
                                      getCurrencyCode(values.currency) +
                                      " " +
                                      amountToCurrency(computeTax(values.items))
                                    }
                                  />
                                </Col>
                                <Col lg={3}>
                                  <InvoiceSummary
                                    label={"Discount"}
                                    icon="mdi mdi-percent"
                                    value={
                                      getCurrencyCode(values.currency) +
                                      " " +
                                      amountToCurrency(
                                        computeDiscount(
                                          values.items,
                                          values.discount
                                        )
                                      )
                                    }
                                  />
                                </Col>
                                <Col lg={3}>
                                  <InvoiceSummary
                                    color={"light"}
                                    label={"Total"}
                                    icon="mdi mdi-calculator"
                                    value={
                                      getCurrencyCode(values.currency) +
                                      " " +
                                      amountToCurrency(
                                        calculateGrandTotal(
                                          values.items,
                                          values.discount
                                        )
                                      )
                                    }
                                  />
                                </Col>
                              </Row>

                              <div className="modal-footer">
                                <Button
                                  disabled={isSubmitting}
                                  type="submit"
                                  className="btn btn-primary"
                                >
                                  Save
                                </Button>
                              </div>
                            </Form>
                          </>
                        )}
                      </Formik>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default NewSale;
